export default __webpack_public_path__ + "media/POPUP-VN.07308470.png";